export const MAX_FILE_PER_DOCUMENT_DATA = 10;

/**
 * Delay between the last update of a Document check with analysis with rejected result and the processing of this
 * check to change the status from `in_progress` to `need_review` or `rejected if settings `documentAnalysis.automaticRejection`.
 * Must be kept sync with the onboarding flow one
 */
export const REJECTED_ANALYSIS_DOCUMENT_PROCESSING_DELAY_IN_MINUTES = 15;
